<template>
  <div v-if="links && !links.length">
    <px-circular-loading v-if="loading"/>
    <div class="card-text pa-3" v-if="!loading">
      Nenhum link para esse registro
    </div>
  </div>
  <v-simple-table v-else>
    <template v-slot:default>
      <tbody>
        <px-link-row v-for="link in links"
                     :key="link.id"
                     :link="link"/>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import LinkRow from './LinkRow.vue';

export default {
  props: {
    links: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
    },
  },
  components: {
    pxLinkRow: LinkRow,
  },
};
</script>
